'use client';

export enum AnalyticsEvent {
  ScrollDepth = 'scroll_depth',
  FilterApplied = 'filter_applied',
  SingleVsSet = 'single_vs_set',
  TemplateViewed = 'template_viewed',
}

export function sendEvent(name: AnalyticsEvent, properties: Record<string, unknown>): void {
  const analytics = getAnalytics();
  if (analytics) {
    const anonymousId = window.anonymousId;
    analytics.track(name, { anonymousId, ...properties }, { anonymousId });
  }
}

type Analytics = {
  track: (name: string, properties: Record<string, unknown>, context?: Record<string, unknown>) => void;
};

function getAnalytics(): Analytics | undefined {
  if (window && 'analytics' in window && window.analytics) {
    return window.analytics as Analytics;
  }
  return undefined;
}
